import { useQuery } from '@tanstack/react-query';

import { AuthQueryOptions } from '@/api';
import { useAuthStore } from '@/stores/AuthStore';

export const useIsDonationHistory = () => {
  const isLogin = useAuthStore((state) => !!state.isLogin);

  const { data: donationHistoryCount = 0 } = useQuery({
    ...AuthQueryOptions['get:/wello/v2/auth/home-donation/history']({
      query: {
        page: 1,
        size: 100,
      },
    }),
    enabled: isLogin,
    select: ({ context }) => context?.totalCount,
  });
  const isDonationHistory = donationHistoryCount > 0;

  return {
    isDonationHistory,
  };
};
